import {
    GETIBANPROVIDERLIST_SUCCESS,
    GETIBANPROVIDERLIST_FAILED,
    RESET_GETIBANPROVIDERLIST,
    LOADING_GETIBANPROVIDERLIST,
    NETWORK_ERROR_GETIBANPROVIDERLIST
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminGetIbanProvider = () => {
    return { type: RESET_GETIBANPROVIDERLIST };
};

const adminGetIBANProviderLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETIBANPROVIDERLIST });
    await adminServices
        .post("getIbanProviderList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(adminGetIBANProvidersuccess(res.data));
                    break;
                default:
                    dispatch(adminGetIBANProviderFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETIBANPROVIDERLIST,
                payload: err
            });
        });
};


function adminGetIBANProvidersuccess(data) {
    return {
        type: GETIBANPROVIDERLIST_SUCCESS,
        payload: data
    };
}
function adminGetIBANProviderFailed(data) {
    return {
        type: GETIBANPROVIDERLIST_FAILED,
        payload: data
    };
}

export { adminGetIBANProviderLists, resetAdminGetIbanProvider }